'use client';

import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { useIntl } from 'react-intl';
import useUser from '@alltrails/context/hooks/useUser';
import { useSelector } from 'react-redux';
import Footer from '../Footer';

type FooterWrapperProps = {
  pageReloadOnLanguageChange?: boolean;
};

const FooterWrapper = ({ pageReloadOnLanguageChange }: FooterWrapperProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();
  const irclickid = useSelector((state: { irclickid: string }) => state.irclickid);
  const intl = useIntl();

  return (
    <div>
      <Footer
        intl={intl}
        user={user}
        wideFooter={false} // only explore pages use a wide footer
        languageRegionCode={languageRegionCode}
        irclickid={irclickid}
        pageReloadOnLanguageChange={pageReloadOnLanguageChange}
      />
    </div>
  );
};

export default FooterWrapper;
